import { styledPolymorphic } from '@qred/components-library';

export const StyledHeader = styledPolymorphic<'header', {}>()(
  (_styled) => _styled`
  width: 100%;
  z-index: 1;
`
);
